/* eslint-disable */
import GraphQL from '../../../../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddSingleWebsiteQueryVariables = GraphQL.Exact<{
  accountId: GraphQL.Scalars['AccountId']['input'];
}>;


export type AddSingleWebsiteQuery = { readonly __typename?: 'Query', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId, readonly defaultFetchingSettings: { readonly __typename?: 'AccountDefaultFetchingSettings', readonly fetchingLocation: GraphQL.FetchingLocation, readonly userAgentSettings: { readonly __typename?: 'UserAgentSettings', readonly customValue: string | null, readonly type: string } } } | null };


export const AddSingleWebsiteDocument = gql`
    query AddSingleWebsite($accountId: AccountId!) {
  account(id: $accountId) {
    id
    defaultFetchingSettings {
      fetchingLocation
      userAgentSettings {
        customValue
        type
      }
    }
  }
}
    `;

/**
 * __useAddSingleWebsiteQuery__
 *
 * To run a query within a React component, call `useAddSingleWebsiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddSingleWebsiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddSingleWebsiteQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAddSingleWebsiteQuery(baseOptions: Apollo.QueryHookOptions<AddSingleWebsiteQuery, AddSingleWebsiteQueryVariables> & ({ variables: AddSingleWebsiteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddSingleWebsiteQuery, AddSingleWebsiteQueryVariables>(AddSingleWebsiteDocument, options);
      }
export function useAddSingleWebsiteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddSingleWebsiteQuery, AddSingleWebsiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddSingleWebsiteQuery, AddSingleWebsiteQueryVariables>(AddSingleWebsiteDocument, options);
        }
export function useAddSingleWebsiteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AddSingleWebsiteQuery, AddSingleWebsiteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AddSingleWebsiteQuery, AddSingleWebsiteQueryVariables>(AddSingleWebsiteDocument, options);
        }
export type AddSingleWebsiteQueryHookResult = ReturnType<typeof useAddSingleWebsiteQuery>;
export type AddSingleWebsiteLazyQueryHookResult = ReturnType<typeof useAddSingleWebsiteLazyQuery>;
export type AddSingleWebsiteSuspenseQueryHookResult = ReturnType<typeof useAddSingleWebsiteSuspenseQuery>;
export type AddSingleWebsiteQueryResult = Apollo.QueryResult<AddSingleWebsiteQuery, AddSingleWebsiteQueryVariables>;